import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductionAuditEventType } from '@enums/production-audit-event-type.enum';
import { ProductionJobAudit } from '@models/ui/production-job-audit.model';
import { ProductionJobSdk } from '@sdks/production-job.sdk';

@Component({
    selector: 'lex-production-job-audit-log',
    templateUrl: './production-job-audit-log.component.html',
    styleUrl: './production-job-audit-log.component.scss',
    standalone: false
})
export class ProductionJobAuditLogComponent {

  public audits: ProductionJobAudit[];
  public isLoading: boolean = true;

  constructor(private productionJobSdk: ProductionJobSdk,
    @Inject(MAT_DIALOG_DATA) data) {
    this.productionJobSdk.getProductionJobAuditLog(data.productionJobId).subscribe(data => {
      this.audits = data.sort((a, b) => {
        const dateA = new Date(a.createdAtDateTimeOffset || 0).getTime();
        const dateB = new Date(b.createdAtDateTimeOffset || 0).getTime();
        return dateB - dateA;
      });
      this.isLoading = false;
    });
  }


  public getTooltipContent(audit: ProductionJobAudit): string {
    if (audit.action === ProductionAuditEventType.GetDownloadLinks && audit.partIndex != null)
      return `${audit.action}
      DownloadIndex: ${audit.partIndex}`;

    return audit.action;
  }
}
